'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Constants = require('../actions/Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Handles changing the app's form configuration received from the API.
 * @param {Object} state - The current form configuration object.
 * @param {FSA} action - The dispatched action.
 * @returns {Object} The new form configuration object.
 */
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loaded: false, data: null };
  var action = arguments[1];

  switch (action.type) {
    case Constants.GET_SAVED_QUOTE_COMPLETE:
    case Constants.GET_RENEWAL_COMPLETE:
      if (!action.error) {
        return {
          loaded: true,
          data: action.payload.data
        };
      }
      if (action.error) {
        return {
          loaded: true
        };
      }

      return state;
    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/reducers/savedQuote.js
// module id = 1734
// module chunks = 0